import React from 'react';

interface Props {
  children: React.ReactNode;
}

export default function MapControlsContainer({ children }: Props) {
  return <div className="map-controls-container">{children}</div>;
}
